import './setupPublicPath';
import React from 'react';
import ReactDOM from 'react-dom';

// import { Application } from "@yulintu/freesia-bootstrap";
import { Application } from "@yulintu/freesia-design";
// import { Application } from "@yulintu/freesia-design-mobile";
import { loadVariablesJSON, loadAppJSON } from './loadResource';
import templates from "./templates";
import { URIUtil } from '@yulintu/freesia-core';
import sso from 'freesia-sso'

import './css/global.less';
import './css/index.less';

const urlParams = URIUtil.parseParams(window.location.href);
if (urlParams && urlParams.firstLogin) {
	let url = window.location.href;
	url = sso._delQueStr(url, 'firstLogin');
	window.history.replaceState({
		path: url
	}, '', url);
}
function render(props = {}) {
	ReactDOM.render(
		<Application global={{}} templates={templates} {...props} />,
		props.container ? props.container.querySelector('#root') : document.querySelector('#root'));
}

if (!window.__POWERED_BY_QIANKUN__) {
	 render()
	// loadVariablesJSON().then((variables) => {
	// 	const appPath = variables.app;
	// 	if (appPath) {
	// 		loadAppJSON(appPath).then((appJsonText) => {
	// 			const appConfig = _.template(appJsonText)(variables);
	// 			const appJson = json5.parse(appConfig);
	// 			render({appJson});
	// 		})
	// 	} else {
	// 		render()
	// 	}
	// })
}



// 以下为微前端的钩子函数

export async function bootstrap() {
	console.log('microapp bootstrap');
}

export async function mount(props) {
	console.log('microapp mount', props);
	render(props);
}

export async function unmount(props) {
	console.log('microapp unmount', props);
	ReactDOM.unmountComponentAtNode(props?.container ? props?.container.querySelector('#root') : document.querySelector('#root'));
}